angular.module( 'acme.view.application.partners.modals.selectList', [
  'ui.router',
  'ui.bootstrap',
  'acme.common.directive.scrollableSelectList',
  'acme.view.application.partners.modals.selectList.controllers'
])

.config(function config( $stateProvider ) {

  // Create both abstract view and template view.
  // Abstract Views are enabled by default
  var partnersModalsSelectList = {
        name: 'application.partners.modals.selectList',
        url: '/partners/modals/selectList',
        views: {
          "main": {
            controller: 'PartnersModalsSelectListController',
            // Assumes the view is entirely self contained
            templateUrl: 'views/application/views/partners/modals/selectList/selectList.tpl.html'
          }
        },
        data: {
          pageTitle: ''
        }
      };

    $stateProvider
      .state(partnersModalsSelectList);
});
